import { useMutation, useQueryClient } from 'react-query';

import { postLocationOnMap } from 'api/InteractiveMap/postLocationOnMap';

const usePostLocationOnMap = () => {
  const queryClient = useQueryClient();

  const {
    isSuccess,
    mutate: createNewLocation,
    isLoading,
  } = useMutation(postLocationOnMap, {
    onSuccess: () => {
      queryClient.invalidateQueries('locations');
    },
    onError: () => {},
  });

  return {
    isSuccess,
    createNewLocation,
    isLoading,
  };
};

export default usePostLocationOnMap;
